export const breakpoints = {
    xs: '380px',
    risk_assessment_xl: '1350px',
    dashboard_cards_xl: '1224px',
    max_potential_limit_card_xs: '459px',
}
